import styled from '@emotion/styled';

export const ContentWrapper = styled.div`
    height: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
`;
